export const FLORIDA_HUB = "/florida-commercial-solar";

/** Florida navigation structure derived from the integration package's pages.json kinds. */
export const FLORIDA_NAV = [
  { label: "Florida Commercial Solar ROI", path: "/florida-commercial-solar", group: "hub" },
  {
    label: "Regions",
    group: "regions",
    items: [
      ["South Florida", "/florida-commercial-solar/south-florida"],
      ["Central Florida", "/florida-commercial-solar/central-florida"],
      ["Tampa Bay", "/florida-commercial-solar/tampa-bay"],
      ["Southwest Florida", "/florida-commercial-solar/southwest-florida"],
      ["Northeast Florida", "/florida-commercial-solar/northeast-florida"],
      ["Panhandle", "/florida-commercial-solar/panhandle"],
    ],
  },
  {
    label: "Industries",
    group: "industries",
    items: [
      ["Hotels & Hospitality", "/florida-commercial-solar/industries/hotels-hospitality"],
      ["Warehouses & Self-Storage", "/florida-commercial-solar/industries/warehouses-self-storage"],
      ["Cold Storage", "/florida-commercial-solar/industries/cold-storage"],
      ["Auto Dealerships", "/florida-commercial-solar/industries/auto-dealerships"],
    ],
  },
  {
    label: "Resources",
    group: "resources",
    items: [
      ["Tax Incentives & Review", "/florida-commercial-solar/incentives"],
      ["C-PACE Financing", "/florida-commercial-solar/financing/c-pace"],
      ["Battery & Demand Charges", "/florida-commercial-solar/battery-demand-charges"],
      ["FPL Utility Guide", "/florida-commercial-solar/utilities/fpl"],
      ["Duke Energy Florida Guide", "/florida-commercial-solar/utilities/duke-energy-florida"],
      ["TECO Utility Guide", "/florida-commercial-solar/utilities/teco"],
      ["JEA Utility Guide", "/florida-commercial-solar/utilities/jea"],
      ["OUC Utility Guide", "/florida-commercial-solar/utilities/ouc"],
    ],
  },
];

const LABELS = Object.fromEntries(
  FLORIDA_NAV.filter((g) => g.items).flatMap((g) => g.items.map(([label, path]) => [path, label])),
);

/** Descriptive labels for every Florida guide/region/utility/industry page (audit fix: no repeated generic labels). */
const LABEL_OVERRIDES = {
  "/florida-commercial-solar": "Florida Commercial Solar Overview",
  "/florida-commercial-solar/incentives": "Florida Commercial Solar Tax Incentives",
  "/florida-commercial-solar/financing/c-pace": "C-PACE Financing in Florida",
  "/florida-commercial-solar/battery-demand-charges": "Battery Storage and Demand Charges",
  "/florida-commercial-solar/utilities/fpl": "FPL Commercial Solar Guide",
  "/florida-commercial-solar/utilities/duke-energy-florida": "Duke Energy Florida Guide",
  "/florida-commercial-solar/utilities/teco": "TECO Commercial Solar Guide",
  "/florida-commercial-solar/utilities/jea": "JEA Distributed Generation Guide",
  "/florida-commercial-solar/utilities/ouc": "OUC Commercial Solar Guide",
  "/florida-commercial-solar/south-florida": "South Florida Commercial Solar Guide",
  "/florida-commercial-solar/central-florida": "Central Florida Commercial Solar Guide",
  "/florida-commercial-solar/tampa-bay": "Tampa Bay Commercial Solar Guide",
  "/florida-commercial-solar/southwest-florida": "Southwest Florida Commercial Solar Guide",
  "/florida-commercial-solar/northeast-florida": "Northeast Florida Commercial Solar Guide",
  "/florida-commercial-solar/panhandle": "Panhandle Commercial Solar Guide",
  "/florida-commercial-solar/industries/hotels-hospitality": "Hotels & Hospitality Solar Guide",
  "/florida-commercial-solar/industries/warehouses-self-storage": "Warehouse & Self-Storage Solar Guide",
  "/florida-commercial-solar/industries/cold-storage": "Cold Storage Solar Guide",
  "/florida-commercial-solar/industries/auto-dealerships": "Auto Dealership Solar Guide",
};

Object.assign(LABELS, LABEL_OVERRIDES);

export function floridaLabel(path) {
  const clean = String(path || "").replace(/\/+$/, "") || path;
  return LABELS[clean] || "Florida Commercial Solar";
}

